import * as tslib_1 from "tslib";
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import strings from 'owa-strings/owa-common-strings';
import optionsStrings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
var containerDiv = null;
var UnsubscribeDialog = /** @class */ (function (_super) {
    tslib_1.__extends(UnsubscribeDialog, _super);
    function UnsubscribeDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsubscribeDialog.prototype.render = function () {
        return (React.createElement(Dialog, { hidden: false, dialogContentProps: {
                type: DialogType.close,
                title: optionsStrings.options_subscriptions_unsubscribeDialogTitle,
                subText: this.props.dialogDetailMessage,
            }, onDismiss: closeDialog },
            React.createElement(DialogFooter, null,
                React.createElement(PrimaryButton, { onClick: this.props.onUnsubscribeCallback, text: optionsStrings.options_subscriptions_continue }),
                React.createElement(DefaultButton, { onClick: closeDialog, text: strings.cancelButton }))));
    };
    return UnsubscribeDialog;
}(React.Component));
export function showUnsubscribeDialog(onUnsubscribeCallback, detailMessage) {
    containerDiv = document.createElement('div');
    containerDiv.id = 'unsubscribeBrandDialog';
    document.body.appendChild(containerDiv);
    ReactDOM.render(React.createElement(UnsubscribeDialog, { onUnsubscribeCallback: function () {
            onUnsubscribeCallback();
            closeDialog();
        }, dialogDetailMessage: detailMessage }), containerDiv);
}
var closeDialog = function () {
    if (containerDiv) {
        ReactDOM.unmountComponentAtNode(containerDiv);
        document.body.removeChild(containerDiv);
        containerDiv = null;
    }
};
//# sourceMappingURL=UnsubscribeDialog.js.map